<template>  
  <div>
    <div class="main">
      <div class="picture" id="eMeterNumPicture"></div>
    </div>
  </div>

</template>

<script>
  import { deviceApi } from "../../../../../static/js/api.js"
  import { showToast } from "../../../../../static/js/utility/utility.js"
  export default {
    name: 'TotalEMeterNum',
    // props:{
    //   deviceNum:{
    //     type:Object,
    //     required:true,
    //   },
    // },
    data() {
      return {
        deviceNum:{
          onlineNum:'',
          offlineNum:'',
        }
      }
    },
    mounted() {
      
    },
    created: async function () {
      this.getWattMetter()
    },
    methods: {
      async getWattMetter(){
        let that = this;
        const res = await deviceApi.getWattMetter()
        if(res.meta.code == '200'){
          that.deviceNum={
            onlineNum:res.data.onlineNum,
            offlineNum:res.data.offlineNum,
          }
          that.drawLine();
        }else{
          showToast(res.meta.message)
          // that.$message.error(res.meta.message)
        }
      },
      // echarts画图函数
      drawLine(){
        let that = this;
        this.$nextTick(function(){
          // console.log(that.deviceNum)
          // 基于准备好的dom，初始化echarts实例
          let myChart = this.$echarts.init(document.getElementById('eMeterNumPicture'))
          // 绘制图表
          // 指定图表的配置项和数据
          let option = {
            tooltip: {
              trigger: 'item',
              formatter: "{a} <br/>{b}: {c} ({d}%)"
            },
            legend: {
              orient: 'vertical',
              x: 'right',
              data:['在线设备','离线设备']
            },
            series: [
              {
                name:'设备统计',
                type:'pie',
                radius: ['50%', '70%'],
                center: ['40%', '50%'],
                avoidLabelOverlap: false,
                color:['#fb5e5b','#8ccf5d'],
                label: {
                  normal: {
                    show: false,
                    position: 'center'
                  },
                  emphasis: {
                    show: true,
                    textStyle: {
                      fontSize: '14',
                      fontWeight: 'bold'
                    }
                  }
                },
                labelLine: {
                  normal: {
                    show: false
                  }
                },
                data:[
                  {value:that.deviceNum.offlineNum, name:'离线设备'},
                  {value:that.deviceNum.onlineNum, name:'在线设备'}
                ]
              }
            ]
          };
          // 使用刚指定的配置项和数据显示图表。
          myChart.setOption(option,true);
        })
      },
      
    },
    watch: {
      
    },
    props: []
  }
</script>

<style lang="scss" scoped>
.picture {
  height: 148px;
  background-color: #fff;
  box-shadow: 0 6px 7px 5px rgba(7,0,2,.06);
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CEnergyManage/BuildingInfo/TotalEMeterNum.vue